<template>
  <!-- 查看大图 -->
  <div class="cbigpic_box" v-if="dialog">
    <i class="btn_close" @click="changeDialog"></i>
    <i id="chos" v-trigger @click="init"></i>
    <!-- Swiper -->

    <div v-if="!isM">
      <div class="swiper-container gallery-top">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in picArr" :key="item.id">
            <img :src="item.url" />
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
        <!-- Add Arrows -->
        <div class="swiper-button-next swiper-button-white"></div>
        <div class="swiper-button-prev swiper-button-white"></div>
      </div>
      <div class="swiper-container gallery-thumbs">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in picArr" :key="item.id">
            <img :src="item.url" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="isM">
      <div class="swiper-container phoneswi">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in picArr" :key="item.id">
            <img :src="item.url" />
            <div class="p_des">{{ item.title }}</div>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination phone_pagin"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    picArr: {
      type: Array,
      default: [],
    },
  },
  directives: {
    trigger: {
      inserted(el, binging) {
        el.click();
      },
    },
  },
  data() {
    return {
      idx: 0,
      isM: false,
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
  },
  methods: {
    //   赋值给参数
    gotData(data) {
      this.idx = data.idx;
    },
    init() {
      this.$nextTick(() => {
        this.initSwiper();
      });
    },
    initSwiper() {
      if (!this.isM) {
        var galleryThumbs = new Swiper(".gallery-thumbs", {
          initialSlide: this.idx,
          spaceBetween: 10,
          slidesPerView: 7,
          observer: true,
          observeParents: true,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          updateOnImagesReady: true,
        });
        var galleryTop = new Swiper(".gallery-top", {
          initialSlide: this.idx,
          spaceBetween: 10,
          observer: true,
          observeParents: true,
          updateOnImagesReady: true,
          pagination: {
            el: ".swiper-pagination",
            type: "fraction",
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: galleryThumbs,
          },
        });
        galleryTop.init();
      } else {
        new Swiper(".phoneswi", {
          initialSlide: this.idx,
          pagination: {
            el: ".phone_pagin",
            type: "fraction",
          },
        });
      }
    },
    //   改变pop显示
    changeDialog() {
      this.$emit("dialog", false);
    },
  },
};
</script>
<style>
@import "../../node_modules/swiper/dist/css/swiper.min.css";
</style>



// WEBPACK FOOTER //
// src/components/cbigpic.vue